
document.addEventListener("DOMContentLoaded", function() {
  var cm = {"bianco lucido":"#ffffff","nero lucido":"#1a1a1a","ocra lucido":"#c8a951","phard lucido":"#d4a89a","bianco matt":"#f0efe8","basalto matt":"#4a4a4a","brina matt":"#c8cfd4","londra matt":"#7a8a8a","foglia matt":"#6b8e5a","nero matt":"#2d2d2d","nocciola matt":"#8b6f47","cerniere cromo":"#c0c0c0","cerniere oro":"#d4af37","cerniere bronzo":"#8b6914","carrara":"url(https://ceramichearcadia.com/wp-content/uploads/2026/01/carrara.png)","travertino":"url(https://ceramichearcadia.com/wp-content/uploads/2026/01/travertino.png)","emperador":"url(https://ceramichearcadia.com/wp-content/uploads/2026/01/emperador.jpg)","nero marquinia":"url(https://ceramichearcadia.com/wp-content/uploads/2026/01/nero-marquina.png)","calacatta":"url(https://ceramichearcadia.com/wp-content/uploads/2026/01/calacatta.png)","bianco e oro lucido":"url(https://ceramichearcadia.com/wp-content/uploads/2026/01/bianco-oro-lucido.png)","bianco e oro rosa lucido":"url(https://ceramichearcadia.com/wp-content/uploads/2026/01/bianco-rosa-lucido.png)","bianco e platino lucido":"url(https://ceramichearcadia.com/wp-content/uploads/2026/01/bianco-platino-lucido.png)","cromo":"#c0c0c0","oro":"#d4af37","bronzo":"#8b6914","bianco":"#ffffff","cemento":"#8a8a8a","nero":"#1a1a1a","sabbia":"#c9b98a","bianco antico":"url(https://ceramichearcadia.com/wp-content/uploads/2025/03/fresia-finitura-1.png)","bianco tr":"url(https://ceramichearcadia.com/wp-content/uploads/2025/03/fresia-collection-finitura-1.png)","ulivo":"url(https://ceramichearcadia.com/wp-content/uploads/2025/03/fresia-ceramiche-arcadia-1.png)","rovere grigio":"url(https://ceramichearcadia.com/wp-content/uploads/2025/03/fresia-finitura-mobile-1.png)","marmo bianco":"url(https://ceramichearcadia.com/wp-content/uploads/2025/03/fresia-finiture-mobili-1.png)","marmo nero":"url(https://ceramichearcadia.com/wp-content/uploads/2025/03/finiture-mobili-fresia-1.png)","salvia":"url(https://ceramichearcadia.com/wp-content/uploads/2025/12/salvia.png)","petrolio":"url(https://ceramichearcadia.com/wp-content/uploads/2025/12/petrolio.jpg)","rovere rc":"url(https://ceramichearcadia.com/wp-content/uploads/2025/12/rovere-rc-3.png)","rovere rs":"url(https://ceramichearcadia.com/wp-content/uploads/2025/12/rovere-rs-3.png)","legno":"#8B6914","laccato":"#e8e4df","bianco/nero lucido - piedi bianchi":"#1a1a1a","bianco/nero lucido - piedi cromo":"#1a1a1a","bianco/nero lucido - piedi oro":"#1a1a1a","bianco/nero matt - piedi bianchi":"#2d2d2d","bianco/nero matt - piedi cromo":"#2d2d2d","bianco/nero matt - piedi oro":"#2d2d2d","bianco lucido - piedi bianchi":"#ffffff","bianco lucido - piedi cromo":"#ffffff","bianco lucido - piedi oro":"#ffffff","bianco lucido - piedi bronzo":"#ffffff","cromo lucido":"#c0c0c0","cromo matt":"#a0a0a0","standard":"#ffffff","nero lucido":"#1a1a1a"};

  /* Colora swatch cerchi */
  document.querySelectorAll(".fx-swatch-circle").forEach(function(dot) {
    var btn = dot.closest(".fx-color-swatch");
    if (!btn) return;
    var name = (btn.dataset.colorName || "").toLowerCase();
    var cl = cm[name] || "#ccc";
    if (cl.indexOf("url(") === 0) {
      dot.style.backgroundImage = cl; dot.style.backgroundColor = "transparent";
      dot.style.backgroundSize = "cover"; dot.style.backgroundClip = "padding-box";  dot.style.overflow = "hidden";
      dot.style.backgroundPosition = "center";
    } else {
      dot.style.backgroundColor = cl;
      
    }
  });

  /* Colora dots nelle specs */
  document.querySelectorAll("#fxSpecColors .fx-spec-color-dot").forEach(function(dot) {
    var parent = dot.closest("[data-color-name]");
    if (!parent) return;
    var name = parent.dataset.colorName || "";
    var cl = cm[name] || "#ccc";
    if (cl.indexOf("url(") === 0) {
      dot.style.backgroundImage = cl; dot.style.backgroundColor = "transparent";
      dot.style.backgroundSize = "cover"; dot.style.backgroundClip = "padding-box";  dot.style.overflow = "hidden";
      dot.style.backgroundPosition = "center";
    } else {
      dot.style.backgroundColor = cl;
      
    }
  });

  /* Selettore colore click (solo prodotti a 1 opzione) */
  if (!document.getElementById("fxOption1Select")) {
    document.querySelectorAll(".fx-color-swatch").forEach(function(btn) {
      btn.addEventListener("click", function() {
        if (btn.disabled) return;
        if (btn.dataset.option3) return; /* 3-opzioni Capannoli: gestito dal blocco dedicato */
        document.querySelectorAll(".fx-color-swatch").forEach(function(x) { x.classList.remove("fx-swatch-active"); });
        btn.classList.add("fx-swatch-active");
        var vi = document.getElementById("fxVariantId");
        var pe = document.getElementById("heroPriceValue");
        var se = document.getElementById("fxSku");
        var sc = document.getElementById("fxSelectedColor");
        if (vi) vi.value = btn.dataset.variantId;
        if (pe) pe.textContent = btn.dataset.price;
        if (se) se.textContent = btn.dataset.sku || "";
        if (sc) sc.textContent = btn.dataset.option1;
      });
    });
  }

  /* Quantita */
  var qi = document.getElementById("fxQty"), qh = document.getElementById("fxQtyHidden");
  var qm = document.getElementById("fxQtyMinus"), qp = document.getElementById("fxQtyPlus");
  if (qm) qm.addEventListener("click", function() { var v = parseInt(qi.value) || 1; if (v > 1) { qi.value = v-1; qh.value = v-1; } });
  if (qp) qp.addEventListener("click", function() { var v = parseInt(qi.value) || 1; if (v < 99) { qi.value = v+1; qh.value = v+1; } });

  /* Accordion toggle */
  setTimeout(function() {
    ["specsToggle","descToggle"].forEach(function(toggleId) {
      var toggle = document.getElementById(toggleId);
      if (!toggle) return;
      var acc = toggle.closest(".fx-specs-accordion");
      var cont = acc ? acc.querySelector(".fx-specs-content") : null;
      var neo = toggle.cloneNode(true);
      toggle.parentNode.replaceChild(neo, toggle);
      neo.addEventListener("click", function(e) {
        e.preventDefault();
        if (acc) acc.classList.toggle("active");
        if (cont) cont.style.display = acc.classList.contains("active") ? "block" : "none";
      });
    });
  }, 3000);

  /* Icone dentro titolo */
  var title = document.querySelector(".fx-product-title");
  var actions = document.querySelector(".fx-product-actions");
  if (title && actions) {
    actions.style.display = "inline-flex";
    actions.style.verticalAlign = "middle";
    actions.style.marginLeft = "0.5rem";
    actions.style.marginBottom = "0";
    title.appendChild(document.createTextNode(" "));
    title.appendChild(actions);
  }

  /* Multi-opzione: Dropdown Misura + Swatch Finitura */
  var opt1Select = document.getElementById("fxOption1Select");
  if (opt1Select && window.variantMap) {
    function findVariant(o1, o2) {
      for (var i = 0; i < window.variantMap.length; i++) {
        if (window.variantMap[i].o1 === o1 && window.variantMap[i].o2 === o2) return window.variantMap[i];
      }
      return null;
    }
    function updateMultiVariant() {
      var o1 = opt1Select.value;
      var activeBtn = document.querySelector("#fxColorOptions .fx-swatch-active");
      var o2 = activeBtn ? activeBtn.dataset.option2 : "";
      if (!o2) {
        var firstBtn = document.querySelector("#fxColorOptions .fx-color-swatch");
        if (firstBtn) { firstBtn.classList.add("fx-swatch-active"); o2 = firstBtn.dataset.option2; }
      }
      var v = findVariant(o1, o2);
      if (v) {
        var vi = document.getElementById("fxVariantId");
        var pe = document.getElementById("heroPriceValue");
        var se = document.getElementById("fxSelectedColor");
        var so = document.getElementById("fxSelectedOption1");
        var sk = document.getElementById("fxSku");
        if (vi) vi.value = v.id;
        if (pe) pe.textContent = v.price;
        if (se) se.textContent = o2;
        if (so) so.textContent = o1;
        if (sk) sk.textContent = v.sku;
      }
    }
    opt1Select.addEventListener("change", updateMultiVariant);
    document.querySelectorAll("#fxColorOptions .fx-color-swatch").forEach(function(btn) {
      btn.addEventListener("click", function() { if(btn.dataset.option3)return;
        document.querySelectorAll("#fxColorOptions .fx-color-swatch").forEach(function(x) { x.classList.remove("fx-swatch-active"); });
        btn.classList.add("fx-swatch-active");
        updateMultiVariant();
      });
    });
    updateMultiVariant();
  }
});

/* === CAPANNOLI finish swatches (colori finiture) === */
(function(){
  var CAP={"cromo": "linear-gradient(135deg,#D9D2C5,#a9a9a9 50%,#dcdcdc)", "nero opaco": "#1e1e1e", "bianco": "#f4f4f4", "nero": "#1e1e1e", "senza led": "#d5d8da", "con led": "#ffe9b3", "acciaio satinato": "linear-gradient(135deg,#cfcfcf,#9a9a9a 50%,#bcbcbc)", "acciaio lucido": "linear-gradient(135deg,#f4f4f4,#b8b8b8 50%,#e2e2e2)", "nichel satinato": "linear-gradient(135deg,#dcdcd6,#a6a6a0 50%,#c8c8c2)", "nichel matt": "#b7b7b1", "ottone satinato": "linear-gradient(135deg,#d3b662,#9c7f2e 50%,#c1a24a)", "bronzo satinato": "linear-gradient(135deg,#a9834e,#6e4f28 50%,#8c6a3c)", "bronzo satinato opaco": "#6f5738", "bronzo scuro": "#3b2f27", "oro": "linear-gradient(135deg,#e6c65c,#b08d2e 50%,#d4af37)", "oro satinato opaco": "#c2a24a", "oro rosa": "linear-gradient(135deg,#e8b7ac,#b87d76 50%,#d8a091)", "oro rosa opaco": "#cca79c", "rame satinato": "linear-gradient(135deg,#d08a54,#8a4f26 50%,#b87333)", "canna fucile satinato lucido": "linear-gradient(135deg,#5a5f64,#2f3438 50%,#484d52)", "canna fucile satinato opaco": "#464b4f", "canna fucile lucido": "linear-gradient(135deg,#4a4f54,#26292d 50%,#3a3e42)", "noir pvd": "linear-gradient(135deg,#3a3a3c,#16161a 50%,#28282c)", "rose pvd": "linear-gradient(135deg,#d8a894,#a86a58 50%,#c48b76)", "champagne pvd": "linear-gradient(135deg,#e6d3a4,#b89a5e 50%,#d4bd7e)", "bianco opaco ral9010": "#ece7d9", "grigio chiaro opaco ral7044": "#c5c7c4", "grigio scuro opaco ral7024": "#474a50", "grigio antracite": "#383e42", "nero opaco ral9005": "#101012", "ruggine": "#8a3b24", "mattone opaco ral2013": "#8e4b34", "rosso opaco ral3013": "#9b332b", "arancione opaco ral2000": "#e0701a", "giallo opaco ral1032": "#dca500", "rosa opaco ral3012": "#cb8d73", "beige opaco ral1015": "#e6d2b5", "verde salvia opaco ral6021": "#89a578", "verde oliva opaco ral6003": "#434733", "blu oceano opaco ral5020": "#1f3438", "blu opaco ral5011": "#1b2733", "celeste opaco ral5024": "#6a93b0"};
  function norm(s){return (s||'').toLowerCase().replace(/[èéÈÉ]/g,'e').trim();}
  function apply(){
    document.querySelectorAll('#fxLaufenSwatches[data-cap-grouped] .fx-swatch-circle, #fxColorOptions[data-cap-fin] .fx-swatch-circle').forEach(function(dot){
      var btn=dot.closest('.fx-color-swatch'); if(!btn) return;
      var cl=CAP[norm(btn.dataset.colorName)]; if(!cl) return;
      if(cl.indexOf('gradient')!==-1){dot.style.backgroundImage=cl;dot.style.backgroundColor='';dot.style.backgroundSize='cover';}
      else{dot.style.background=cl;dot.style.backgroundImage='';
        var h=cl.replace('#','');if(h.length===3)h=h.replace(/./g,'$&$&');
        var r=parseInt(h.substr(0,2),16),g=parseInt(h.substr(2,2),16),bb=parseInt(h.substr(4,2),16);
        if((0.2126*r+0.7152*g+0.0722*bb)>210)dot.style.boxShadow='inset 0 0 0 1px rgba(0,0,0,0.18)';}
    });
  }
  window.fxCapRecolor=apply;
  if(document.readyState!=='loading')apply();else document.addEventListener('DOMContentLoaded',apply);
  setTimeout(apply,600);setTimeout(apply,1800);
})();


/* === CAPANNOLI grouped selector (dropdown famiglia + swatch filtrati) === */
(function(){
  var st=document.createElement("style"); st.textContent=".fx-cap-fh{display:none!important}"; (document.head||document.documentElement).appendChild(st);
  var LACC=["bianco opaco ral9010","beige opaco ral1015","grigio chiaro opaco ral7044","grigio scuro opaco ral7024","grigio antracite","nero opaco ral9005","ruggine","mattone opaco ral2013","rosso opaco ral3013","arancione opaco ral2000","giallo opaco ral1032","rosa opaco ral3012","verde salvia opaco ral6021","verde oliva opaco ral6003","blu oceano opaco ral5020","blu opaco ral5011","celeste opaco ral5024","bianco lucido","nero opaco","bianco","nero","senza led","con led"];
  function fam(name){
    var n=(name||"").toLowerCase().trim();
    if(/pvd$/.test(n)) return "PVD";
    if(n.indexOf("acciaio")===0) return "Acciaio";
    if(LACC.indexOf(n)>=0) return "Laccati";
    return "Galvaniche";
  }
  var ORDER=["Galvaniche","Acciaio","PVD","Laccati"];
  var LABEL={"Galvaniche":"Galvaniche","Acciaio":"Acciaio satinato","PVD":"PVD","Laccati":"Laccati (RAL)"};
  function init(cont){
    if(cont.dataset.capReady) return; cont.dataset.capReady="1";
    var btns=[].slice.call(cont.querySelectorAll(".fx-color-swatch"));
    if(btns.length<2) return;
    var fams=[];
    btns.forEach(function(b){ var f=fam(b.dataset.colorName||b.dataset.option1||b.dataset.option2); b.dataset.fam=f; if(fams.indexOf(f)<0)fams.push(f); });
    fams.sort(function(a,b){return ORDER.indexOf(a)-ORDER.indexOf(b);});
    if(fams.length<2) return;
    var sel=document.createElement("select");
    sel.className="fx-cap-fam";
    sel.style.cssText="width:100%;padding:12px 40px 12px 16px;border:1px solid var(--fx-border-light,#D9D2C5);border-radius:7px;font-size:0.9rem;font-weight:600;background:#fff url('data:image/svg+xml,%3Csvg width=%2212%22 height=%228%22 viewBox=%220 0 12 8%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cpath d=%22M1 1l5 5 5-5%22 stroke=%22%23666%22 stroke-width=%221.5%22 fill=%22none%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22/%3E%3C/svg%3E') no-repeat right 16px center;color:var(--fx-text);cursor:pointer;margin-bottom:12px;-webkit-appearance:none;-moz-appearance:none;appearance:none";
    fams.forEach(function(f){ var o=document.createElement("option"); o.value=f; o.textContent=LABEL[f]||f; sel.appendChild(o); });
    cont.parentNode.insertBefore(sel, cont);
    function show(f){ btns.forEach(function(b){ if(b.dataset.fam===f) b.classList.remove("fx-cap-fh"); else b.classList.add("fx-cap-fh"); }); }
    function pickFirst(){ var f=btns.filter(function(b){return b.dataset.fam===sel.value && !b.classList.contains("fx-cap-fh");})[0]; if(f) f.click(); }
    sel.addEventListener("change", function(){
      show(sel.value);
      var act=cont.querySelector(".fx-color-swatch.fx-swatch-active");
      if(!act || act.dataset.fam!==sel.value) pickFirst();
      if(window.fxCapRecolor) window.fxCapRecolor();
    });
    /* ri-applica dopo il cambio Misura (updateSwatchImages resetta display) */
    var mis=[document.getElementById("fxOption1Select"),document.getElementById("fxOpt1Select"),document.getElementById("fxOpt2Select")].filter(Boolean);
    mis.forEach(function(md){ md.addEventListener("change", function(){ setTimeout(function(){
      show(sel.value);
      var act=cont.querySelector(".fx-color-swatch.fx-swatch-active");
      if(!act || act.classList.contains("fx-cap-fh")) pickFirst();
      if(window.fxCapRecolor) window.fxCapRecolor();
    }, 70); }); });
    var a=cont.querySelector(".fx-color-swatch.fx-swatch-active");
    var start=(a&&a.dataset.fam)||fams[0];
    sel.value=start; show(start);
  }
  function run(){ document.querySelectorAll("#fxLaufenSwatches[data-cap-grouped], #fxColorOptions[data-cap-fin]").forEach(init); }
  if(document.readyState!=="loading") run(); else document.addEventListener("DOMContentLoaded", run);
  setTimeout(run,500); setTimeout(run,1500);
})();
